export const LOCAL_STORAGE_KEY = '_superbowl-squares_';
export const WEB_APP_URL = 'https://superbowl-squares.com';
